module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "epa-natural-gas--cover.dfae4da5.jpg";